import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { toGameError } from '@/api/errors'
import { Spinner } from '@/components/Spinner'

export function PanelLoading() {
  const { t } = useTranslation()
  return (
    <div className="p-6">
      <Spinner label={t('panel.loading')} />
    </div>
  )
}

export function PanelError({ error }: { error: unknown }) {
  const e = toGameError(error)
  return (
    <div className="m-4 border-l-[3px] border-danger bg-bg-deep px-4 py-3 text-[14px] text-ink" role="alert">
      {e.message}
    </div>
  )
}

/** A dossier section heading: Oswald label over a hairline. */
export function Section({ title, children, testId }: { title: string; children: ReactNode; testId?: string }) {
  return (
    <section className="border-t border-border px-5 py-4" data-testid={testId}>
      <h3 className="soc-label mb-3">{title}</h3>
      {children}
    </section>
  )
}
